<form [formGroup]="form">

    <h2>Bevestiging van je aanvraag</h2>

    <div class="overview">
        <h3 class="overview__title">Overzicht aanvraag</h3>
        <div class="overview__content">
            <div class="overview__list"
                style="margin-bottom: 0;">
                <h4 class="table-title">
                    Adviesgesprek isolatie
                    <button class="table-edit"
                        type="button"
                        (click)="router.navigate(['/selecteer-je-klus'], {replaceUrl:true})">
                        <i-edit style="stroke: white;"></i-edit>
                    </button>
                </h4>
                <table class="table">
                    <tbody class="table-body">
                        <tr class="table-row"
                            *ngFor="let item of visibleInvoiceItems">
                            <td class="table-column">{{ item.key }}</td>
                            <td class="table-column">{{ item.description }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <ig-footer>
        <ig-button-primary (click)="router.navigate(['/contactgegevens'], {replaceUrl:true})">vorige stap
        </ig-button-primary>
        <span class="spacer"></span>
        <ig-button-secondary [isDisabled]="sendButtonDisabled"
            (click)="sendIt($event)">
            aanvraag versturen
        </ig-button-secondary>
    </ig-footer>

</form>
